import '../Assests/css/views/home.css';
import '../Assests/css/views/typing.css';
import { useState, useEffect } from 'react';

const roles = ['Backend Developer', 'Algo Trading', 'Machine Learning', 'Systems Design'];

function useTypingEffect() {
    const [text, setText] = useState('');
    const [roleIndex, setRoleIndex] = useState(0);
    const [isDeleting, setIsDeleting] = useState(false);

    useEffect(() => {
        const currentRole = roles[roleIndex];
        const speed = isDeleting ? 50 : 100;

        const timeout = setTimeout(() => {
            setText(currentRole.substring(0, text.length + (isDeleting ? -1 : 1)));

            if (!isDeleting && text === currentRole) setTimeout(() => setIsDeleting(true), 2000);
            if (isDeleting && text === '') { setIsDeleting(false); setRoleIndex(i => (i + 1) % roles.length); }
        }, speed);

        return () => clearTimeout(timeout);
    }, [text, isDeleting, roleIndex]);

    return text;
}

export default function Home(){
    const text = useTypingEffect();

    return(
        <section id="home" className="home">
             <img className="profilePic" src="https://res.cloudinary.com/dttgvr9lo/image/upload/v1771484920/NEW_dscny1.png" alt="Profile" />
            <h1 className='position'>DEVELOPER</h1>
            <p className="typing-text">{text}<span className="cursor">|</span></p>
        </section>
    );
}